export default {
    $vuetify: {
        save: 'Salvar',
        close: 'Fechar',
        cancel: 'Cancelar',
        add: 'Adicionar',
        remove: 'Remover',
        tryAgain: 'Tente novamente',
        uploadError: 'Erro ao fazer upload...',
        dragImage: 'Arraste a image aqui ou clique para procurar',
        uploading: 'Fazendo upload...',
        dataIterator: {
            pageText: '{0}-{1} de {2}',
            noResultsText: 'Nenhum dado encontrado',
            loadingText: 'Carregando itens...',
        },
        dataTable: {
            name: 'Nome',
            action: 'Ação',
            edit: 'Editar',
            delete: 'Deletar',
            itemsPerPageText: 'Linhas por página:',
            ariaLabel: {
            sortDescending: ': Ordenado decrescente. Ative para remover a ordenação.',
            sortAscending: ': Ordenado crescente. Ative para ordenar decrescente.',
            sortNone: ': Não ordenado. Ative para ordenar crescente.',
            },
            sortBy: 'Sort by',
        },
        dataFooter: {
            pageText: '{0}-{1} de {2}',
            itemsPerPageText: 'Itens por página:',
            itemsPerPageAll: 'Todos',
            nextPage: 'Próxima página',
            prevPage: 'Página anterior',
            firstPage: 'Página primeira',
            lastPage: 'Página última',
        },
        datePicker: {
            itemsSelected: '{0} selecionados',
        },
        noDataText: 'Não há dados disponíveis',
        carousel: {
            prev: 'Visão anterior',
            next: 'Próxima visão',
        },
        calendar: {
            moreEvents: 'Mais {0}',
        },
        fileInput: {
            counter: '{0} files',
            counterSize: '{0} files ({1} in total)',
        },
        rules: {
            required: 'Campo obrigatório',
            email: 'Campo deverá ser um email válido',
            name: 'Campo precisa ser igual ou menor que 100 caracteres',
            number: 'Campo precisa ser um número valido',
        },
        drawer: {
            dashboard: "Dashboard",
            customer: "Clientes",
            department: "Departamentos",
            collection: "Coleções",
            product: "Produtos",
            order: "Pedidos",
            editProfile: "Editar Perfil",
            logout: "Sair",
            login: "Login"
        },
        dialog: {
            close: "Fechar",
            success: "Sucesso!",
            warning: "Atenção!",
            info: "Atenção!",
            error: "Erro!",
            no: "Não",
            yes: "Sim"
        },
        login: {
            forgotPassword: "Esqueceu a senha?",
            name: "Login",
            password: "Senha"
        },
        collection: {
            deleteQuestion: "Confirma a exclusão da categoria?",
            addProducts: 'Começe adicionando produtos a sua coleção',
            products: 'Produtos da Coleção',
            info: 'Informações da Coleção',
            name: 'Nome',
            actived: 'Ativado',
            department: 'Departamento',
            nonRequiredDeparment: 'Departamento não é obrigatório'
        },
        department: {
            deleteQuestion: "Confirm deletion of department?",
            info: 'Informações do Departamento',
            name: 'Nome',
            actived: 'Ativado',            
        },
        product: {
            deleteQuestion: "Confirma a exclusão do produto?",
            price: 'Preço',
            weight: 'Peso (KG)',
            name: 'Nome',
            image: 'Imagens',
            description: 'Descrição',
            actived: 'Ativado',
            info: 'Informações do Produto',            
        }                        
    }
}